module.exports = __webpack_public_path__ + "static/media/work-icon.e72b2029.png";